import { jsx } from 'panel';
import { ButtonEl } from 'common/components/button';
import { ButtonTheme } from 'common/components/button/constants';
import { ModalEl } from 'common/components/modal';
export function template() {
  return jsx(ModalEl, {
    sel: '.upsell-modal',
    attrs: {
      open: this.state.open,
      closeable: this.attr("closeable"),
      'hide-close-button': true
    },
    on: {
      change: this.helpers.handleModalChange
    }
  }, jsx("div", {
    sel: '.upsell-modal-content'
  }, this.state.backgroundImage ? jsx("div", {
    sel: '.upsell-modal-background'
  }, jsx("img", {
    sel: '.upsell-modal-background-image',
    attrs: {
      src: this.state.backgroundImage
    }
  })) : null, jsx("div", {
    sel: '.upsell-modal-body'
  }, jsx("div", {
    sel: '.upsell-modal-header'
  }, this.attr("header")), jsx("div", {
    sel: '.upsell-modal-description'
  }, this.attr("description")), jsx("div", {
    sel: '.upsell-modal-footer'
  }, jsx("div", {
    sel: '.upsell-modal-footer-left'
  }, this.attr("learn-more-url") ? jsx(ButtonEl, {
    sel: '.upsell-modal-learn-more-btn',
    attrs: {
      theme: ButtonTheme.Tertiary,
      role: "button",
      href: this.attr("learn-more-url"),
      target: "_blank"
    }
  }, "Learn More") : null), jsx("div", {
    sel: '.upsell-modal-footer-right'
  }, this.attr("closeable") ? jsx(ButtonEl, {
    sel: '.upsell-modal-cancel-btn',
    attrs: {
      theme: ButtonTheme.Tertiary,
      role: "button"
    },
    on: {
      click: this.helpers.handleClickCancel
    }
  }, "Cancel") : null, jsx(ButtonEl, {
    sel: '.upsell-modal-upgrade-btn',
    attrs: {
      theme: ButtonTheme.Primary,
      role: "button",
      icon: "share",
      href: "/pricing/",
      target: "_blank"
    },
    on: {
      click: this.helpers.handleClickUpgrade
    }
  }, this.attr("upgrade-text")))))));
}